import React, { useEffect } from "react";
import { Modal, Tooltip } from "antd";
import styles from "../../../styles/Components/new-dashboard/bot-performance/BotDetailModal.module.css";
import { formatAIMode } from "../../../utility/formatter-helper";
import { calcDifferenceInDays } from "../../../utility/helper";
import moment from "moment";
import BotPerformanceChart from "../../../shared/BotPerformanceChart";
import { Link, useLocation } from "react-router-dom";
import { IoInformationCircleOutline, IoTrophySharp } from "react-icons/io5";
import { MdInfo } from "react-icons/md";
import { GoClockFill } from "react-icons/go";
import { FaLightbulb, FaPercentage, FaRegFilePdf } from "react-icons/fa";
import { HiArrowTrendingUp } from "react-icons/hi2";
import { RiExchangeFill } from "react-icons/ri";
import { FaFilePdf } from "react-icons/fa6";
import { BsCalendarDateFill } from "react-icons/bs";
import EmptyBox from "../../../ui/EmptyBox";
import capitalize from "antd/es/_util/capitalize";
import { PiChartLineUpBold } from "react-icons/pi";

const BotDetailModal = ({ visible, setShow, data = {}, showChart = true }) => {
  const {
    bot_name: name,
    status,
    profit_percent: profit,
    win_rate: winRate,
    ai_assistant_mode: strategy,
    exchange_id: exchangeId,
    end_date: endDate,
    start_date: startDate,
    balance_date_list = [],
    balance_lists = [],
    best_trade,
    exchange_name: exchange,
    pdf_url: pdfUrl,
  } = data;

  const { pathname } = useLocation();

  const onClose = (e) => {
    e.stopPropagation();
    setShow(false);
  };

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 300);
    }
  }, [visible]);

  return (
    <Modal
      title={`${name} - Detailed Performance`}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      styles={{ header: { marginBottom: "20px" } }}
    >
      <div className={styles.content}>
        <ul className={styles.infoList}>
          {status && (
            <li>
              <span className={styles.label}>
                <PiChartLineUpBold />
                Status:
              </span>{" "}
              <span
                style={{
                  color: `${status === "Active" ? "#0AAF47" : "#AF0A0A"}`,
                }}
              >
                {status}
              </span>
            </li>
          )}
          {best_trade && (
            <li>
              <span className={styles.label}>
                <PiChartLineUpBold /> Best Trade:
              </span>
              <div>
                <span
                  style={{
                    // color: "#52c41a",
                    fontWeight: "bold",
                  }}
                >
                  Pnl:
                </span>{" "}
                <span className={styles.value}>${best_trade?.pnl}, </span>
                <span
                  style={{
                    fontSize: "14px",
                    // , color: "#909090"
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>Coin:</span>{" "}
                  <span className={styles.value}>{best_trade?.asset}</span>
                </span>
                ,{" "}
                <span
                  style={{
                    fontSize: "12px",
                    // , color: "#909090"
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>Date:</span>{" "}
                  <span className={styles.value}>
                    {moment(best_trade?.date).format("MMM Do YYYY, h:mm:ss a")}
                  </span>
                </span>
              </div>
            </li>
          )}
          <li>
            <span className={styles.label}>
              <PiChartLineUpBold /> Strategy:
            </span>{" "}
            <span className={styles.value}>{formatAIMode?.[strategy]}</span>
          </li>
          <li>
            <span className={styles.label}>
              <PiChartLineUpBold /> Profit:
            </span>{" "}
            {profit !== "N/A" ? (
              <span className={styles.value}>
                {Number(profit)?.toFixed(2)}%
              </span>
            ) : (
              "-"
            )}
          </li>
          <li>
            <span className={styles.label}>
              <PiChartLineUpBold /> Win Rate:
            </span>{" "}
            {winRate !== "N/A" ? (
              <span
                className={styles.value}
                // style={{ color: `${Number(winRate) > 50 ? "green" : "grey"}` }}
              >
                {winRate}%
              </span>
            ) : (
              "-"
            )}
          </li>
          {(exchange || exchangeId) && (
            <li>
              <span className={styles.label}>
                <PiChartLineUpBold />
                Exchange:
              </span>
              <span className={styles.value}>
                {exchange ||
                  (exchangeId === "cryptocrispy"
                    ? "Demo Exchange"
                    : capitalize(exchange || exchangeId))}
              </span>
            </li>
          )}
          <li>
            <span className={styles.label}>
              <PiChartLineUpBold /> Activity Duration:
            </span>{" "}
            <span className={styles.value}>
              {startDate ? (
                <Tooltip
                  title={
                    <>
                      {moment(startDate).format("lll")} -{" "}
                      {moment(endDate).format("lll")}
                    </>
                  }
                  color="geekblue"
                  className={styles.tooltip}
                >
                  {calcDifferenceInDays(endDate, startDate)}
                  <IoInformationCircleOutline size={15} color="#0C4CFC" />
                </Tooltip>
              ) : (
                "-"
              )}
            </span>
          </li>

          <li>
            <span className={styles.label}>
              <PiChartLineUpBold /> Last Activity Date:
            </span>{" "}
            {endDate ? (
              <span className={styles.value}>
                {moment(endDate).format("lll")}
              </span>
            ) : (
              "-"
            )}
          </li>

          {pdfUrl && (
            <li className={styles.pdf}>
              {/*<span className={styles.label}>*/}
              {/*  <FaFilePdf color="#e74c3c" />*/}
              {/*  Performance report:*/}
              {/*</span>*/}
              <Link
                to={`${pathname}/bot-report?pdf=${pdfUrl}`}
                className={styles.pdfLink}
                // href={pdfUrl}
                // target="_blank"
                // rel="noreferrer"
              >
                <FaRegFilePdf />
                Export to PDF
              </Link>
            </li>
          )}
        </ul>

        {showChart && (
          <div className={styles.balanceChart}>
            <h6>Balance Performance</h6>
            {balance_date_list?.length > 0 && visible ? (
              <BotPerformanceChart
                balanceDateList={balance_date_list}
                balanceLists={balance_lists}
                showOption
              />
            ) : (
              <>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <p style={{ fontSize: "12px", marginBottom: ".5rem" }}>
                    This bot hasn't made any trades yet, so there is no chart
                    available.
                  </p>
                  <EmptyBox
                    useCase="analytic"
                    size={40}
                    style={{ margin: "0 auto" }}
                  />
                </div>
              </>
            )}
          </div>
        )}
      </div>
      {showChart && (
        <p className={styles.footer}>
          Detailed performance charts and metrics are available in the{" "}
          <Link to="/bot-automation">Bot</Link> section.
        </p>
      )}
    </Modal>
  );
};

export default BotDetailModal;
